import { render, staticRenderFns } from "./login_secondary_confirmation.vue?vue&type=template&id=24777090&scoped=true&"
import script from "./login_secondary_confirmation.vue?vue&type=script&lang=js&"
export * from "./login_secondary_confirmation.vue?vue&type=script&lang=js&"
import style0 from "./login_secondary_confirmation.vue?vue&type=style&index=0&id=24777090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24777090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
